import { createFileRoute } from '@tanstack/react-router'

import { DefaultLoader } from '#components/default-loader.tsx'
import { HomePage } from '#features/home/home-page.tsx'

export const Route = createFileRoute('/_app/$workspace/_dashboard/')({
  component: HomePage,
  pendingComponent: DefaultLoader,
})
